import { SolutionUser } from "../solution.tsx";
import { Position } from "./position.tsx";

export class AvatarContextMenu {
    private position: Position;
    private avatar: SolutionUser;

    constructor(position: Position, avatar: SolutionUser) {
        this.setPosition(position);
        this.setAvatar(avatar);
    }

    static fromJSON(json: any) {
        return new AvatarContextMenu(Position.fromJSON(json.position), SolutionUser.fromJSON(json.avatar));
    }

    setPosition(newPosition: Position) {
        this.position = newPosition;
    }
    setAvatar(newAvatar: SolutionUser) {
        this.avatar = newAvatar;
    }

    getPosition() {
        return this.position;
    }
    getAvatar() {
        return this.avatar;
    }
}